import { render, staticRenderFns } from "./rekondpkr.vue?vue&type=template&id=650f4045&scoped=true"
import script from "./rekondpkr.vue?vue&type=script&lang=js"
export * from "./rekondpkr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f4045",
  null
  
)

export default component.exports